export default __webpack_public_path__ + "static/media/Nesha_Laser_0005_Particle_6.65636d51.png";